// Which client this web bundle is running in. The Cordova shell loads this same
// site with `#/<android|ios>/<version>/...` in the hash, and initFirebase keeps
// that in localStorage (`cordova_hash_info`) so it survives reloads that drop the
// hash. Read at module load, before initFirebase runs.
export type ClientPlatform = 'web' | 'cordova-android' | 'cordova-ios'

function detect(): ClientPlatform {
  if (typeof window === 'undefined') return 'web'
  const fromHash = location.hash.match(/^#\/(android|ios)\//)?.[1]
  if (fromHash) return `cordova-${fromHash}` as ClientPlatform
  try {
    const stored = JSON.parse(localStorage.getItem('cordova_hash_info') ?? 'null')
    if (stored?.os === 'android' || stored?.os === 'ios') return `cordova-${stored.os}` as ClientPlatform
  } catch { /* storage unavailable or malformed */ }
  return 'web'
}

export const clientPlatform: ClientPlatform = detect()
export const isCordovaShell = clientPlatform !== 'web'
